<template>
      <div>    
        <b-row class="justify-content-md-center">
            <b-col cols='8'>
                <h1>About Us </h1>
                <hr>
                <p>
                  Welcome to bTr Works. We created this tool with one goal in mind:
                  Simple, easy and clear tracking of Bitcoin, altcoins, tokens and all major cryptocurrencies. 
                  No hassle - no hype! The tool is free for you to use and we hope that you will find
                  it useful in making solid trading decisions. Please let us know what you think via any of our 
                  social channels. Your comments, suggestions and requests are welcome here. 
                  We’re committed to continuing development of this tool and look forward to hearing about your 
                  experience using it.
                </p>

<p>Thanks,</p>

<p> -Nick and Rich- </p>
            </b-col>        
        </b-row>    
      </div>
</template>

<script>

// import Chart from 'chart.js'

export default {
  props: {},
  data: function () {
    return {
      status: 'updated'
    }
  },
  computed: {
  },
  created () {},
  methods: {
    closeBox: function () {
      console.log('emit event to close about box', true)
      this.$emit('close-about', false)
    }
  },
  mounted () {
  }
}
</script>

<style scoped>
#head{
  padding-left: 1px;
  font-size: 100%;
}
.card-header{
  background-color:rgba(255, 192, 7, 1);
  font-family: 'Lato';
  color: white;
  padding: 7px;
  height: 35px;
} 
.card-footer{
  border: 1px solid white;
  background: grey;
  color: white;
}
#commentsButton {
  color: rgba(255, 192, 7, 1);
  background-color:rgba(108, 117, 125, 1);
}
.close{
  color: grey;
  background: none;
  font-size: 2rem;
  border: none;
  text-shadow: none;
  opacity: 1;
}
.socialicon {
  margin: 10px;
  color: grey;
}
</style>




// WEBPACK FOOTER //
// src/components/splash/btr-about.vue